import React, { useState } from 'react';
import styles from '../../../component/addCategoryForm/addCategoryForm.module.css';
import styless from '../../../component/scheduleComps/scheduleList/partList.module.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { addTopProductsThunk, deleteTopProductsThunk } from '../../../redux/appearanceSlice';
import PopularProductSelector from './PopularProductSelector';
import DeleteTitleConfirmation from './DeleteTitleConfirmation';

const Manufacturer2 = ({ manufacturer, level3, handleImageUpload, topproduct }) => {
    const [loading, setLoading] = useState(false);
    const [isDeleteConfirmationOpen, setIsDeleteConfirmationOpen] = useState(false);
    const dispatch = useDispatch()


    const formik = useFormik({
        initialValues: {
            manufacturer: topproduct?.manufacturer || "",
            productnumber: 2,
            product: topproduct?.product || [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            manufacturer: Yup.string().required("Manufacturer is required."),
        }),
        onSubmit: async (values) => {
            setLoading(true);
            await dispatch(addTopProductsThunk(values));
            setLoading(false);
        },
    });

    const handleDeleteTitle = async () => {
        if (!topproduct?._id) {
            formik.setValues({ manufacturer: '', productnumber: 2, product: [] });
            return;
        }

        setIsDeleteConfirmationOpen(true);
    };

    const confirmDeleteTitle = async () => {
        setLoading(true);
        const action = await dispatch(deleteTopProductsThunk(2));
        setLoading(false);
        if (deleteTopProductsThunk.fulfilled.match(action)) {
            formik.setValues({ manufacturer: '', productnumber: 2, product: [] });
            setIsDeleteConfirmationOpen(false);
        }
    };

    return (
        <form onSubmit={formik.handleSubmit} style={{ background: '#F0F1F3B2', marginBottom: '20px', padding: '8px 16px 16px' }}>
            <div style={{ display: 'flex', gap: 12, alignItems: 'end' }}>
                <label className={styles.addCatLabel} style={{ flex: 1 }}>
                    Title 2

                <input
                    type="text"
                    name="manufacturer"
                    value={formik.values.manufacturer}
                    className={styles.addCatInput}
                    onBlur={formik.handleBlur}
                    placeholder="Enter title"
                    onChange={formik.handleChange}
                />

                {formik.errors.manufacturer && (
                    <div className={styles.errorText}>
                        {formik.errors.manufacturer}
                    </div>
                )}
                </label>
                <button type='button' onClick={handleDeleteTitle} disabled={loading} style={{ marginBottom: 8, border: '1px solid #fecaca', borderRadius: 6, background: '#fff', color: '#dc2626', padding: '10px 14px', cursor: 'pointer' }}>
                    Delete title
                </button>
            </div>

            <label className={styles.addCatLabel}>Products</label>
            <PopularProductSelector
                products={formik.values.product || []}
                onChange={(products) => formik.setFieldValue('product', products)}
            />

            <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                <button type='button' className={styless.cancelBtn} onClick={() => formik.resetForm()}>Cancel</button>
                <button type='submit' className={styless.submitBtn} disabled={loading}>{loading ? 'please wait..' : 'Save Changes'}</button>
            </div>
            <DeleteTitleConfirmation
                open={isDeleteConfirmationOpen}
                title={formik.values.manufacturer}
                isDeleting={loading}
                onCancel={() => setIsDeleteConfirmationOpen(false)}
                onConfirm={confirmDeleteTitle}
            />
        </form>
    );
};

export default Manufacturer2;
